exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".changed-container button{transform:scale(2);margin-top:20px}.changed-container h4{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Changed.vue
// module id = 212
// module chunks = 11